<div class="overwriteContainer">
  <span class="message">{{data.message}}</span>
  <div class="controls">
    <button mat-raised-button class="confirm" (click)="confirm()">{{data.choice1}}</button>
    <button mat-raised-button class="cancel" (click)="deny()">{{data.choice2}}</button>
  </div>
</div>